import { AppEnvironment, type OpenExternalLink } from "@/client/core/Core.api";
import { LabsMessageToPlatformType } from "@/client/core/platform-types/labs.api";
import { createSendPluginMessage } from "@/client/core/services/plugin-send-message";
import { getAppEnvironment } from "@/client/utils/getAppEnvironment";
import { noop } from "@/shared/utils/noop";

/**
 * Opens a link in the system browser from a page without a Core: the home
 * page in the Labs plugin, which can discard a `target="_blank"` navigation.
 * It asks the host over the plugin channel, as Core's `openExternalLink` does.
 *
 * Undefined on the website and in the sidepanel, which run the website and
 * open links the way it does, so a plain `target="_blank"` anchor is right.
 *
 * Create it when the page boots, not on click: the channel is set up by the
 * host's handshake, which arrives once, early.
 */
export const createEmbeddedLinkOpener = (): OpenExternalLink | undefined => {
    switch (getAppEnvironment()) {
        case AppEnvironment.Plugin: {
            const sendMessage = createSendPluginMessage(noop, noop);
            return (url) => {
                sendMessage({ type: LabsMessageToPlatformType.OpenExternalLink, url });
            };
        }
        case AppEnvironment.Website: {
            return undefined;
        }
    }
};
